import * as yup from 'yup';
import CrudPage from '@modules/cruds/CrudPage';
import Form from './ItemRelationForm';
import { defaultConfigComponent } from './ItemRelations';

const itemRelationSchema = yup.object().shape({
  name: yup.string().required().label('Name'),
  elementRelationTypeLid: yup.string().required().label('Relation type'),
});

const ItemRelationPage = props => {
  const itemDefaultValues = {};
  return (
    <CrudPage
      key={'itemRelationPage'}
      configComponent={defaultConfigComponent}
      form={Form}
      defaultValues={itemDefaultValues}
      validationSchema={itemRelationSchema}
    />
  );
};
export default ItemRelationPage;
